// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import AmountCellRenderer from '../../../reports/shared/report-cell-renderers/amount-cell-renderer';
import LinkToClaimsRenderer from './link-to-claims-renderer';

const LinkedAmountRenderer = props => props.value ?
    <LinkToClaimsRenderer {...props}>
        <AmountCellRenderer {...props}/>
    </LinkToClaimsRenderer> :
    <AmountCellRenderer {...props}/>;

LinkedAmountRenderer.displayName = 'LinkedAmountRenderer';
LinkedAmountRenderer.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
};

export default LinkedAmountRenderer;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/components/linked-amount-renderer.js